import axios from 'axios';
import * as Paths from '@/components/common/paths';

// import {test_data_pa} from './test_data' //テスト用

// 音声解析APIを呼び出す関数
export const analyzeRecordedData = async (recordedDataBlob, recordedParam, analysisTypeFlag) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = async () => {
            // 音声データをBase64に変換
            const wavDataBase64 = reader.result.split(',')[1];
            // リクエストのペイロードを構築
            const payload = {
                wav: wavDataBase64,
                filename: recordedParam.filename,
                category: recordedParam.category,
                age: recordedParam.age,
                gender: recordedParam.gender,
                mode: analysisTypeFlag,
                record_second: recordedParam.seconds,
            };

            const payloadJson = JSON.stringify(payload);

            const headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                    Authorization: 'Basic cGF0YWthVXNlcjpwYXRha2FBY2Nlc3MxMjM0IQ==',
                    'xxx-api-key': 'RwE7wFjKjY9nglnK9QY4P3b96lcZkpSc17Gw080M',
            };

            try {
                // Send the request to the endpoint
                const response = await axios.post(`${Paths.INVOCATION_URL}`, payloadJson, { headers: headers });

                if (response.status == 200) {
                    // 質解析の判定trueは実行
                    resolve({
                        analyzeData: response.data,
                        wavDataBase64: wavDataBase64,
                    });
                } else {
                    // エラー時の処理
                    const errorMessage = '音声データの解析中にエラーが発生しました:' + response.status;
                    reject(errorMessage);
                }

            } catch (error) {
                // エラー時の処理
                const errorMessage = '音声データの解析中にエラーが発生しました:' + error;
                reject(errorMessage);
            }
        };
        // ファイルをBase64に変換
        reader.readAsDataURL(recordedDataBlob);
    });
};
